import { A as I } from "../../AutocompletePageProvider-BoV4iLil.js";
import { u as m } from "../../jsxRuntime.module-Bzuv3cXw.js";
import { s } from "../../index.es-XNBESE3P.js";
import { B as a } from "../../BaseElement-iXMoOyxY.js";
import { useCallback as l } from "preact/hooks";
function C({
  children: o,
  hit: e,
  as: t,
  componentProps: n
}) {
  const r = l(() => {
    e && "productId" in e && s((c) => c.recordSearchClick("autocomplete", e));
  }, [e]);
  return /* @__PURE__ */ m(a, { onClick: r, as: t, componentProps: n, className: "ns-autocomplete-element", children: o });
}
function k({ children: o, class: e, onSubmit: t }) {
  return /* @__PURE__ */ m(
    "div",
    {
      className: `ns-autocomplete-element ${e || ""}`,
      onClick: t,
      onKeyDown: (n) => {
        n.key === "Enter" && t();
      },
      children: o
    }
  );
}
function y({ as: o, componentProps: e, onSearchInput: t, children: n }) {
  const r = {
    ...e,
    onInput: (p) => {
      t(p.target);
    }
  }, c = o ?? "input";
  return o || (r.type = "search"), /* @__PURE__ */ m(c, { ...r, children: n });
}
export {
  C as AutocompleteElement,
  I as AutocompletePageProvider,
  k as HistoryElement,
  y as SearchInput
};
